// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "汽机控制系统",
      "tec": "郭南",
      "week": "1-6周",
      "add": "实训楼F座103自控"
    },
    {
      "sub": "热工过程控制系统",
      "tec": "梁强",
      "week": "1-7,12-16周",
      "add": "教学楼A座221电力"
    },
    [
      {
        "sub": "自动化专业英语",
        "tec": "沈震",
        "week": "4-7周",
        "add": "实训楼F座202自控"
      },
      {
        "sub": "计算机仿真",
        "tec": "马艺骅",
        "week": "12-17周",
        "add": "实训楼C座303"
      }
    ],
    0,
    0
  ],
  "2": [
    {
      "sub": "组态软件应用",
      "tec": "张娜",
      "week": "1-4周",
      "add": "实训楼F座420自实验室"
    },
    0,
    {
      "sub": "新能源控制技术",
      "tec": "刘宁",
      "week": "1-7,12-16周",
      "add": "实训楼F座103自控"
    },
    0,
    0
  ],
  "3": [
    [
      {
        "sub": "汽机控制系统",
        "tec": "郭南",
        "week": "1-6周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "热工保护与顺序控制",
        "tec": "贾晓梅",
        "week": "12-17周",
        "add": "实训楼F座202自控"
      }
    ],
    {
      "sub": "分散控制系统",
      "tec": "王祥凤",
      "week": "1-6周",
      "add": "实训楼F座102自控"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "组态软件应用",
      "tec": "张娜",
      "week": "1-4周",
      "add": "实训楼F座420自实验室"
    },
    {
      "sub": "能源经济基础",
      "tec": "马铭婧",
      "week": "1-7,12周",
      "add": "教学楼C座110教务"
    },
    [
      {
        "sub": "自动化专业英语",
        "tec": "沈震",
        "week": "4-7周",
        "add": "实训楼F座102自控"
      },
      {
        "sub": "计算机仿真",
        "tec": "马艺骅",
        "week": "12-17周",
        "add": "实训楼C座303"
      }
    ],
    0,
    0
  ],
  "5": [
    {
      "sub": "热工过程控制系统",
      "tec": "梁强",
      "week": "1-7,12-16周",
      "add": "教学楼B座224自控"
    },
    {
      "sub": "分散控制系统",
      "tec": "王祥凤",
      "week": "1-6周",
      "add": "教学楼B座121自控"
    },
    [
      {
        "sub": "就业创业指导",
        "tec": "邓苏栩包妍",
        "week": "1-5周",
        "add": "教学楼C座110教务"
      },
      {
        "sub": "热工保护与顺序控制",
        "tec": "贾晓梅",
        "week": "12-17周",
        "add": "实训楼F座202自控"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
